export const initialState = () => ({
  all: [],
  recent: [],
  filters: ['red', 'orange'/*, 'yellow'*/, 'active'],
  patient: {
    text: '',
    patientId: '',
  },
  fromDate: '',
  toDate: '',
  limit: 10,
  offset: 0,
  pageInfo: {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: 0,
    endCursor: 0,
  },
  count: 0,
  countAll: 0,
});

export default initialState();
